export const PlayFilledIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 20C5 20.7246 5.39188 21.3925 6.02439 21.7459C6.65691 22.0994 7.43111 22.0831 8.04819 21.7033L21.0482 13.7033C21.6397 13.3393 22 12.6945 22 12C22 11.3055 21.6397 10.6607 21.0482 10.2967L8.04819 2.29668C7.43111 1.91694 6.65691 1.90065 6.02439 2.25409C5.39188 2.60754 5 3.27544 5 4V20Z"
        fill="currentColor"
      />
    </svg>
  );
};
